import Module from '@/store/resource/common/module';
import FormSubmissionCollections from '@/store/resource/formSubmissionCollections';
import api from '@/factories/api';

let module = new Module(new FormSubmissionCollections());

module.add('actions', {
  async generateSchema({ commit, getters }, id) {
    try {
      const path = `form/submission_collections/${id}/generate_schema`;
      return await api().post(path);
    } catch (error) {
      throw error;
    }
  },
});

export default module.create();
